import { date } from 'quasar'

export default function (value, format = 'YYYY-MM-DDTHH:mm:ss.SSSZ') {
  const timeStamp = new Date(value).getTime()

  return date.formatDate(timeStamp, format)
}
